//
// Copyright 2024 DXOS.org
//

export const RPC_TIMEOUT = 20_000;
